import { useTranslation } from 'react-i18next'

import { Alert } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'

type Props = {
  hasUnimportedBids: boolean
  compact?: boolean
}

export const UnimportedBidBanner = ({
  hasUnimportedBids,
  compact = false,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (!hasUnimportedBids) return null

  if (compact) {
    // Compact Alert (alert-placement.md §0): 見出し + 説明を 1 つの流れに置く。
    return (
      <CompactAlert
        description={t('common:bidding.unimportedBid.body')}
        status="warning"
        title={t('common:bidding.unimportedBid.title')}
      />
    )
  }

  return (
    <Alert
      flexShrink={0}
      description={t('common:bidding.unimportedBid.body')}
      status="warning"
      title={t('common:bidding.unimportedBid.title')}
    />
  )
}
